import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable()
export class PerfilService {
    private urlModulo = `${environment.urlAPI}/perfil`;

    constructor(private http: HttpClient) { }

    /**
     * Recupera a lista dos perfis do sistema
     */
    public getListaPerfil(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.http.get(`${this.urlModulo}-lista`)
                .subscribe({
                    next: (response: any) => {
                        if (response.type === true) {
                            resolve(response.data.perfil);
                        } else {
                            reject(response.data);
                        }
                    },
                    error: (error) => {
                        reject(error);
                    }
                });
        });
    }

    /**
     * Retorna uma lista com todos os trabalhos realizados pelo auditor
     * @param codUsuario Código do usuário auditor
     */
    public getDeclaracaoAuditor(codUsuario: number): Promise<any> {
        const params = new HttpParams().set('codUsuario', codUsuario.toString());
        
        return new Promise((resolve, reject) => {
            this.http.get(`${this.urlModulo}-declaracaoauditor`, { params })
                .subscribe({
                    next: (response: any) => {
                        if (response.type === true) {
                            resolve(response.data.retorno);
                        } else {
                            reject(response.data);
                        }
                    },
                    error: (error) => {
                        reject(error);
                    }
                });
        });
    }
}


// WEBPACK FOOTER //
// /app/src/app/services/perfil.service.ts